import { getWizardConfig } from "@/config/wizardConfig";
import { EmployeeContributionData } from "../types/contributionTypes";

export const INITIAL_EMPLOYEE_DATA: EmployeeContributionData = {
  UserAccountID: "",
  EmployeeID: 0,
  FirstName: "",
  LastName: "",
  EmployerMaxMatch: 0,
  EmployerMaxAnnualContribution: 0,
  EmployeeSalary: 0,
};

/**
 * Format currency values with proper rounding
 */
export const formatContributionAmount = (amount: number): number => {
  return Math.round(amount * 100) / 100;
};

/**
 * Calculate employer match based on employee contribution and max match
 */
export const calculateEmployerMatch = (
  employeeContribution: number,
  employerMaxMatch: number,
): number => {
  return Math.min(employeeContribution, employerMaxMatch);
};

/**
 * Check if employer has matching program
 */
export const hasEmployerMatching = (employerMaxMatch: number): boolean => {
  return employerMaxMatch > 0;
};

/**
 * Validate contribution percentage is within valid range
 */
export const isValidContributionPercentage = (percentage: number): boolean => {
  return percentage >= 0 && percentage <= 100;
};

/**
 * Calculate annual contribution amount from percentage and salary
 */
export const calculateAnnualContribution = (
  percentage: number,
  salary: number,
): number => {
  return (percentage / 100) * salary;
};

/**
 * Calculate per-paycheck amount from annual amount
 */
export const calculatePerPaycheckAmount = (
  annualAmount: number,
  payPeriods: number = getWizardConfig().contributions.paychecksPerYear,
): number => {
  return annualAmount / payPeriods;
};

/**
 * Check if two amounts are within tolerance (for floating point comparison)
 */
export const isWithinTolerance = (
  amount1: number,
  amount2: number,
  tolerance: number = getWizardConfig().contributions.contributionTolerance,
): boolean => {
  return Math.abs(amount1 - amount2) <= tolerance;
};
